import { render, staticRenderFns } from "./lim.vue?vue&type=template&id=02f5324a&scoped=true"
import script from "./lim.vue?vue&type=script&lang=js"
export * from "./lim.vue?vue&type=script&lang=js"
import style0 from "./lim.vue?vue&type=style&index=0&id=02f5324a&prod&scoped=true&lang=css"
import style1 from "./lim.vue?vue&type=style&index=1&id=02f5324a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f5324a",
  null
  
)

export default component.exports